import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.6.5_@types+node@18.18.4_eslint@8.51.0_sass@1.69.3_stylelint@15.10.3_typescript@5.2.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import lp_45global from "/opt/buildhome/repo/app/middleware/lp.global.ts";
export const globalMiddleware = [
  validate,
  lp_45global
]
export const namedMiddleware = {}